import { css } from 'styled-components';
import { createBKJTextInputThemeVariantStyles } from './BKJTextInput.utils.js';
export const BKJThemeTextInput = {
    RoundEdges: createBKJTextInputThemeVariantStyles(),
    ComboBoxSeamlessRounded: createBKJTextInputThemeVariantStyles(),
    NoStyles: createBKJTextInputThemeVariantStyles({
        fontSize: '14px',
        border: 'unset',
        borderRadius: 'unset',
        boxShadow: 'none',
        disabledBorder: 'unset',
        invalidBorderColor: 'unset',
        padding: '0',
        focusBorderColor: 'AccentPurple',
        activeBackgroundColor: 'White',
        disabledBackgroundColor: 'Grey3',
        fontColor: 'TextDarkGrey',
        placeholderColor: 'Grey6',
        backgroundColor: 'White',
        background: 'White',
    }),
    BigChungusSearchGoldMember: createBKJTextInputThemeVariantStyles({
        fontSize: '16px',
        border: css `
      ${({ theme }) => `1px solid ${theme.colors.Grey6};`}
    `,
        minHeight: '52px',
        height: '52px',
        borderRadius: '0px',
        boxShadow: 'none',
        disabledBorder: 'unset',
        backgroundColor: 'White',
        background: 'White',
        invalidBorderColor: 'unset',
        padding: '0px 0px 0px 12px',
        inputPadding: '0',
        focusBorderColor: 'AccentPurple',
        activeBackgroundColor: 'White',
        disabledBackgroundColor: 'Grey3',
        fontColor: 'TextSubtleGrey',
        placeholderColor: 'Grey4',
        fontFamily: 'PoppinsTextMedium',
    }),
};
//# sourceMappingURL=BKJTextInput.theme.js.map